<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <b-button variant="primary" class="float-right mb-1 ml-1" v-if="loginState.isAdministrator" :disabled="!expenseSelected" v-on:click="sendExpenses()">
          <i class="cui-envelope-closed icons font-lg"/> Maila kvitton</b-button>
        <b-dropdown  variant="primary" class="float-right mb-1" :disabled="!expenseSelected">
          <template slot="button-content">
            <i class="cui-cloud-download icons font-lg"/> Nedladdning
          </template>
          <b-dropdown-item v-on:click="downloadExcel()">Excel</b-dropdown-item>
          <b-dropdown-item v-on:click="downloadZip()">Zip</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
    <b-card>
      <div slot="header">Bearbetade utgifter
          <div class="card-header-actions">
              <b-spinner v-if="loading" class="mr-1" type="border" small />
          </div>
      </div>
      <b-form inline>
        <div v-if="loginState.isSuperUser">
          <b-form-group>
            <label for="companyDropdown" class="mb-1 mr-1">Företag</label>
            <CompaniesDropDown id="companyDropdown" class="mr-1"  @onCompanySelected="companySelected"/>
          </b-form-group>   
        </div>
        <div>
          <b-form-group>
            <label for="dateDropdown" class="mb-1 mr-1">Datum</label>
            <date-picker id="dateDropdown" lang="en" v-model="selectedMonth" type="month" format="YYYY-MM" v-on:change="loadExpenses()"></date-picker> 
          </b-form-group>
        </div>
      </b-form>
      <multiselect class="mt-1" v-model="filteredValue" :options="options" :multiple="true" 
        group-values="items" group-label="groupName" :group-select="true"
        selectGroupLabel="Tryck enter för att välja grupp" 
        deselectGroupLabel="Tryck enter för att välja bort grupp"
        selectLabel="Tryck enter för att välja" 
        deselectLabel="Tryck enter för att välja bort"
        selectedLabel="Vald"
        placeholder="Sök eller välj i resultatet för att filtrera" track-by="name" label="name">
          <span slot="noResult">Inga värden passar värdet du vill filtrera</span>
      </multiselect>
      
    <table class="table table-striped table-sm mt-3">
          <thead>
            <tr>
              <th style="width:16%">Namn</th>
              <th style="width:10%">Datum</th>
              <th style="width:17%">Projekt</th>
              <th style="width:23%">Kategori</th>
              <th style="width:7%" class="text-center">Spec</th>
              <th style="width:6%" class="text-center">Låst</th>
              <th style="width:8%" class="text-center">Kvitto</th>
              <th style="width:9%" class="text-right">Belopp</th>
              <th style="width:4%" class="text-right"><input type="checkbox" v-model="allExpensesSelected" v-on:click="checkAllSelected()"></th>
            </tr>
          </thead>
          
          <tbody>
            <tr
              v-for="expense in filteredResult"
              :key="expense.id">
              <td style="width:16%"><span style="cursor:pointer" v-on:click="addFilter('user', expense.user)">{{expense.user}}</span></td>
              <td style="width:10%"><span style="cursor:pointer" v-on:click="addFilter('date', expense.date)">{{expense.date }}</span></td>
              <td style="width:17%"><span style="cursor:pointer" v-on:click="addFilter('project', expense.project)">{{expense.project}}</span></td>
              <td style="width:23%"><span style="cursor:pointer" v-on:click="addFilter('category', expense.category)">{{expense.category}}</span></td>
              <td style="width:7%" class="text-center">
                <router-link
                  v-if="expense.salarySpecificationId" :to="{path: '/salaryspecifications/' + expense.salarySpecificationId}">
                  <a href="#"><i class="icon-link icons font-lg"/></a>
                </router-link>
              </td>
              <td style="width:6%" class="text-center"><i class="icon-check icons font-lg" v-if="expense.isLocked" style="color:green" ></i></td>
              <td style="width:8%" class="text-center">
                <a href="#" v-on:click="downloadReceipt(expense)" v-if="expense.receiptFileName">
                  <i class="icon-paper-clip icons font-lg"/>
                </a>
              </td>
              <td style="width:9%" class="text-right">{{expense.cost | currency}}</td>
              <td style="width:4%" class="text-right">
                <input type="checkbox" v-model="expense.isSelected">
              </td>
            </tr>
          </tbody>
          <tfoot >
            <tr class="border-top">
              <td colspan="7" class="text-right">
                <strong>Summa:</strong>
              </td>
              <td style="width:9%" class="text-right">{{sum | currency}}</td>
              <td style="width:4%"></td>
            </tr>
            <tr>
              <td colspan="7" class="text-right">
                <strong>Vald summa:</strong>
              </td>
              <td style="width:9%" class="text-right">{{selectedSum | currency}}</td>
              <td style="width:4%"></td>
            </tr>                               
          </tfoot>
        </table>    
    </b-card>
    <b-modal id="selectDistributionChannelModal" size="sm" title="Välj kanal">
      <DistributionChannelsDropdown ref="distributionChannelDropdown" @onChannelSelected="channelSelected"/>

      <template slot="modal-footer" slot-scope="{ ok, cancel }">
        <b-button @click="cancel()">
          Cancel
        </b-button>
        <b-button variant="primary"  @click="onDistributionChannelAccepted()">
          <b-spinner v-if="sending" class="mr-1" type="border" small />{{sending ? "Skickar" : "Ok" }}
        </b-button>
      </template>
      
    </b-modal>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import DatePicker from 'vue2-datepicker'
import CompaniesDropDown from '../components/CompaniesDropDown'
import DistributionChannelsDropdown from '../components/DistributionChannelsDropdown'
import { globalStore } from "../../shared/helpers";
import { userService, expensesService } from "../../shared/services";
import { fail } from 'assert';
import { connect } from 'net';
import { all } from 'q';
import { constants } from 'fs';
import { filter } from 'minimatch';
import Vue from 'vue'

export default {
  components: {
      Multiselect,
      DatePicker,
      CompaniesDropDown,
      DistributionChannelsDropdown,
  },
  computed: {
    loginState : function() {
      return globalStore.loginState;
    },
    filteredResult() {
      if(!this.result) return [];
      if(!this.filteredValue) return this.result;
      var filteredResult = this.result;

      this.filteredValue.forEach(filter => {
        filteredResult = filteredResult.filter(function(e) {
          return e[filter.category] == filter.name;
        });
      });

      return filteredResult;
    },
    sum() {
      var sum = 0;
      this.filteredResult.forEach(p => sum += p.cost);
      return sum;
    },
    selectedSum() {
      var sum = 0;
      this.selectedExpenses.forEach(p => sum += p.cost);
      return sum;
    },
    selectedExpenses() {
      return this.filteredResult.filter(p => p.isSelected);
    },
    expenseSelected() {
      return this.selectedExpenses.some(p => p);
    }
  },
  data () {
    return {
      allExpensesSelected: false,
      selectedMonth : null,
      loading: true,
      selectedCompany: null,
      options: [],
      filteredValue: [],
      result: null,
      selectedDistributionChannel: null,
      sending: false,
    }
  },
  methods: {
    addFilter(category, name) {
      this.result.forEach(p => p.isSelected = false);
      if(this.filteredValue.some(p => p.name == name)) return;
      this.filteredValue.push({"name":name,"category":category});
    },
    loadExpenses: function() {
      this.loading = true;
      var selectedCompanyId = globalStore.loginState.user.companyId;
      if(this.selectedCompany) selectedCompanyId = this.selectedCompany.id;
      expensesService.getAllProcessed(selectedCompanyId, this.$moment(this.selectedMonth).format("YYYY-MM-01"))
        .then(result => {
          this.loading = false;
          this.allExpensesSelected = false;
          this.filteredValue = [];
          result.forEach(p => {
            p.date = this.$moment(p.spentDate).format("YYYY-MM-DD");
            p.isSelected = false;
          });

          const projects = {groupName: "Projekt", items:[...new Set(result.map(item => item.project))].map(p => ({name:p, category: 'project'}))};
          const categories = {groupName: "Kategori", items:[...new Set(result.map(item => item.category))].map(p => ({name:p, category: 'category'}))};
          const users = {groupName: "Person", items:[...new Set(result.map(item => item.user))].map(p => ({name:p, category: 'user'}))};
          const dates = {groupName: "Datum", items:[...new Set(result.map(item => item.date))].map(p => ({name:p, category: 'date'}))};

          this.options = [projects, users, categories, dates];
          this.result = result;

        }).catch(() => {
          this.loading = false;
          this.ShowToast("Fel", "Ett okänt fel uppstod när hanterade utlägg skulle hämtas", "danger");
        }
      );
    },
    companySelected(company) {
      this.selectedCompany = company;
      this.loadExpenses();
    },
    checkAllSelected() {
      this.filteredResult.forEach(p => p.isSelected = false);
      this.allExpensesSelected = !this.allExpensesSelected;
      this.filteredResult.forEach(p => p.isSelected = this.allExpensesSelected);
    },
    downloadExcel() {
      expensesService.downloadAllProcessedAsExcel(this.filteredResult.filter(p => p.isSelected).map(p => p.id));
    },
    downloadZip() {
      expensesService.downloadAllProcessedAsZip(this.filteredResult.filter(p => p.isSelected).map(p => p.id));
    },
    sendExpenses() {
      this.$bvModal.show('selectDistributionChannelModal');
      this.$refs.distributionChannelDropdown.loaded();      
    },
    channelSelected(distributionChannel) {
      this.selectedDistributionChannel = distributionChannel;
    },
    onDistributionChannelAccepted() {
      this.sending = true;
      var request = {
        distributionChannelId : this.selectedDistributionChannel.id,
        expenses : this.selectedExpenses.map(a => a.id)
      }

      expensesService.mailExpenses(request).then(() => {
          this.ShowToast("Klart", "Utläggskvitton skickades", "success");
          this.sending = false;
          this.$bvModal.hide('selectDistributionChannelModal');
      }).catch(() => {
        this.ShowToast("Fel", "Ett okänt fel uppstod då kvitton skulle skickas", "danger");
        this.sending = false;
      })
    },
    downloadReceipt(entry) {
        var expense  = {
            id: entry.id,
            receiptFileName: entry.receiptFileName
        }

        expensesService.downloadReceipt(expense);
    }
  },
  mounted() {
    this.selectedMonth = this.$moment();
    this.loadExpenses();
  }

}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
  .form-inline label {
    justify-content: left !important
  }
</style>
